import React from "react";
import { AlertOctagon, DollarSign } from "lucide-react";
import { shiftDays, hours, DAY_LABELS } from "@/lib/faultFormat";

export function FaultRow({ row, index, maxHours, days, startIso, onOpen }) {
  const dayCells = row.days || [];
  const peak = Math.max(...dayCells, 0.0001);
  const accent = row.critical ? "#B91C1C" : row.cost ? "#C2410C" : "#156F5B";
  return (
    <div className="grid grid-cols-12 gap-3 px-5 py-4 border-b border-[#F0F2F1] last:border-0 items-center hover:bg-[#F9FAFB] cursor-pointer"
      style={{ transition: "background-color .2s ease" }}
      onClick={() => onOpen(row)}
      data-testid={`fault-row-${index}`}
    >
      <div className="col-span-12 lg:col-span-3 min-w-0">
        <div className="text-sm font-heading font-semibold text-[#212121] flex items-center gap-2">
          {row.critical && <AlertOctagon className="h-3.5 w-3.5 text-[#B91C1C] shrink-0" />}
          <span className="truncate" title={row.rule}>{row.rule}</span>
        </div>
        <div className="text-[11px] text-[#6B7280] mt-1 truncate">{row.site_dis}</div>
      </div>

      <div className="col-span-6 lg:col-span-2">
        <div className="flex items-center gap-2">
          <div className="flex-1 h-2 rounded-full bg-[#F3F4F6] overflow-hidden">
            <div className="h-full rounded-full" style={{ width: `${Math.max((row.hours / maxHours) * 100, 2)}%`, background: accent, transition: "width .5s ease" }} />
          </div>
          <span className="text-xs font-heading font-semibold text-[#4D4D4D] w-20 text-right" data-testid={`fault-duration-${index}`}>
            {hours(row.hours)}
          </span>
        </div>
      </div>

      <div className="col-span-6 lg:col-span-1 text-right text-sm font-heading font-semibold text-[#212121]" data-testid={`fault-cost-${index}`}>
        {row.cost ? `$${row.cost.toLocaleString(undefined, { maximumFractionDigits: 0 })}` : "—"}
      </div>

      <div className="col-span-12 lg:col-span-4">
        <div className="flex gap-1" data-testid={`fault-timeline-${index}`}>
          {dayCells.map((h, i) => (
            <div key={`${startIso}-${i}`} className="flex-1">
              <div className="h-8 rounded bg-[#F3F4F6] relative overflow-hidden" title={`${DAY_LABELS[new Date(`${shiftDays(startIso, i)}T00:00:00`).getDay()]} · ${hours(h)}`}>
                {h > 0 && (
                  <div
                    className="absolute bottom-0 left-0 right-0 rounded"
                    style={{ height: `${Math.max((h / peak) * 100, 12)}%`, background: accent, opacity: 0.9, transition: "height .5s ease" }}
                  />
                )}
              </div>
              {days <= 7 && (
                <div className="mt-1 text-[9px] text-[#9CA3AF] text-center">
                  {DAY_LABELS[new Date(`${shiftDays(startIso, i)}T00:00:00`).getDay()]}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="col-span-12 lg:col-span-2 text-xs text-[#4D4D4D] truncate" title={(row.equips || []).join(", ")}>
        {(row.equips || []).length > 1 ? `${row.equips[0]} +${row.equips.length - 1}` : row.equips?.[0] || "—"}
      </div>
    </div>
  );
}
